import { Select } from 'antd';
import _ from 'lodash';
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  createSemesterActivity,
  getActivityItems,
  getSemesterTimetables,
  updateSemesterActivity,
} from '../../../api/semesterProduct.api';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import {
  IActivityItem,
  IGetActivityItems,
  IGetSemesterTimetables,
} from '../../../models/semesterProduct.model';
import { RootState } from '../../../store/rootReducer';
import ErrorResponse from '../../ErrorResponse';
import Loader from '../../Loader';
import EvaluationTable from './EvaluationTable';
import EvaluationHWTable2 from './EvaluationHWTable2';
import { IGetEvaluationItemTree } from '../../../models/evaluationItem.model';
import { getEvaluationItemTree } from '../../../api/evaluationItem.api';
import EvaluationNewTable2 from './EvaluationNewTable2';
import SelectSemesterCourseSubject from '../../SelectSemesterCourseSubject';
import { IGetSemesterLessonPlans } from '../../../models/semesterLessonPlan2.model';
import { getSemesterLessonPlans } from '../../../api/semesterLessonPlan2.api';
import {
  deleteSemesterEvaluation,
  getSemesterEvaluationHW,
  getSemesterEvaluations,
  postSemesterEvaluationHW,
  putSemesterEvaluationHW,
} from '../../../api/semesterEvaluation.api';
import {
  IGetSemesterEvaluationHW,
  IGetSemesterEvaluations,
  IPostSemesterEvaluationHW,
  ISemesterEvaluation,
  ISemesterEvaluationHW,
} from '../../../models/semesterEvaluation.model';
import EvaluationPbt from './EvaluationPbt';

interface IProps {
  chosenCourseList: any;
  semesterInput: any;
  courseInput: any;
}

const Evaluation: FC<IProps> = ({
  chosenCourseList,
  semesterInput,
  courseInput,
}) => {
  const { t } = useTranslation();
  const { successNotification, infoNotification } = useNotification();
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetSemesterTimetables>();
  const {
    data: res2,
    isLoading: isLoading2,
    error: error2,
    execute: execute2,
  } = useAxios<IGetActivityItems>();
  const {
    data: res3,
    isLoading: isLoading3,
    error: error3,
    execute: execute3,
  } = useAxios<IGetEvaluationItemTree>();
  const {
    data: res4,
    isLoading: isLoading4,
    error: error4,
    execute: execute4,
  } = useAxios<IGetSemesterEvaluationHW>();
  const {
    data: res5,
    isLoading: isLoading5,
    error: error5,
    execute: execute5,
  } = useAxios<IGetSemesterLessonPlans>();
  const {
    data: res6,
    isLoading: isLoading6,
    error: error6,
    execute: execute6,
  } = useAxios<IGetSemesterEvaluations>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios<IPostSemesterEvaluationHW>();
  const {
    data: deleteRes,
    isLoading: deleteIsLoading,
    error: deleteError,
    execute: deleteExecute,
  } = useAxios();

  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // GR0001 = 평가 구분
  const GR0001 = commonCodes.find(
    (item) => item.commonCode === 'GR0001',
  )?.detailCode;
  const [learningYearCode, setLearningYearCode] = useState('');
  const [semesterGBN, setSemesterGBN] = useState('');
  const [courseCode, setCourseCode] = useState<number>();
  const [courseIndex, setCourseIndex] = useState<number>();
  const [learningTypeCode, setLearningTypeCode] = useState<string>();
  const [semesterCourseCode, setSemesterCourseCode] = useState<number>();
  const [data, setData] = useState<IActivityItem[]>([]);
  // 저장 시 사용
  const [lessonPlanCode, setLessonPlanCode] = useState<number>();
  const [subjectCode, setSubjectCode] = useState<number>();
  const [semesterEvaluations, setSemesterEvaluations] = useState<
    ISemesterEvaluation[]
  >([]);

  // 학기 선택 변경 시 대응
  useEffect(() => {
    setCourseIndex(undefined);
    setLearningTypeCode(undefined);
  }, [courseInput]);

  useEffect(() => {
    if (semesterInput) {
      setLearningYearCode(semesterInput.year);
      setSemesterGBN(semesterInput.semesterDiv);
    }
  }, [semesterInput]);

  useEffect(() => {
    if (semesterCourseCode) {
      execute(getSemesterTimetables(semesterCourseCode));
    }
  }, [semesterCourseCode]);

  useEffect(() => {
    if (res2 && !isLoading2) {
      setData(_.cloneDeep(res2.data));
    }
  }, [res2, isLoading2]);

  useEffect(() => {
    if (deleteRes && !deleteIsLoading) {
      successNotification(t('common.message.delete'));
      if (lessonPlanCode) execute4(getSemesterEvaluationHW({ lessonPlanCode }));
    }
  }, [deleteRes, deleteIsLoading]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.save1'));
      if (lessonPlanCode) {
        execute4(getSemesterEvaluationHW({ lessonPlanCode }));
      }
    }
  }, [submitRes, submitIsLoading]);

  useEffect(() => {
    semesterCourseCode &&
      subjectCode &&
      execute5(getSemesterLessonPlans({ semesterCourseCode, subjectCode }));
  }, [semesterCourseCode, subjectCode]);

  useEffect(() => {
    if (
      learningYearCode &&
      semesterGBN &&
      courseCode &&
      learningTypeCode &&
      semesterCourseCode
    ) {
      execute6(
        getSemesterEvaluations({
          learningYearCode,
          semesterGBN,
          courseCode,
          learningTypeCode,
          semesterCourseCode,
        }),
      );
    }
  }, [
    learningYearCode,
    semesterGBN,
    courseCode,
    learningTypeCode,
    semesterCourseCode,
  ]);

  useEffect(() => {
    if (res6?.data && !isLoading6) {
      setSemesterEvaluations(res6.data);
    }
  }, [res6, isLoading6]);

  const onSetLearningTypeCode = (value: string) => {
    if (
      !learningYearCode ||
      !semesterGBN ||
      !courseCode ||
      !value ||
      !semesterCourseCode
    )
      return;

    if (value === 'HW') {
      execute3(getEvaluationItemTree('HW'));
    } else if (value === 'PA') {
      execute2(
        getActivityItems({
          learningYearCode,
          semesterGBN,
          courseCode,
          learningTypeCode: value,
          semesterCourseCode,
        }),
      );
    }
    setLearningTypeCode(value);
  };

  const onSetData = (index: number, key: string, value: any) => {
    const _data = [...data];
    // @ts-ignore
    _data[index][key] = value;
    if (key === 'monthSeq') {
      _data[index].timetableSeq = null;
    }
    setData(_data);
  };

  const onDelete = (value: number) => {
    deleteExecute(deleteSemesterEvaluation(value));
  };

  const onSubmit = (record: IActivityItem) => {
    if (!semesterCourseCode || !record.timetableSeq) return;

    if (record.semesterSeqEvaluationCode) {
      // update
      submitExecute(
        updateSemesterActivity(
          semesterCourseCode,
          record.semesterSeqEvaluationCode,
          {
            timetableSeq: record.timetableSeq,
          },
        ),
      );
    } else {
      // create
      submitExecute(
        createSemesterActivity(semesterCourseCode, record.timetableSeq, {
          prdCurriculumCode: record.prdCurriculumCode,
          learningTypeCode,
        }),
      );
    }
  };

  const onHWSubmit = (record: ISemesterEvaluationHW) => {
    if (lessonPlanCode && learningTypeCode) {
      if (record.evaluationItemCode === 0)
        return infoNotification(t('program.semester.message18'));
      if (record.evaluationCode === 0) {
        submitExecute(
          postSemesterEvaluationHW({
            evaluationItemCode: record.evaluationItemCode,
            evaluationType: learningTypeCode,
            lessonPlanCode,
          }),
        );
      } else {
        submitExecute(
          putSemesterEvaluationHW(record.evaluationCode, {
            evaluationItemCode: record.evaluationItemCode,
            evaluationType: learningTypeCode,
            lessonPlanCode,
          }),
        );
      }
      setLessonPlanCode(lessonPlanCode);
    }
  };

  const onRowClick = (lessonPlanCode: number) => {
    setLessonPlanCode(lessonPlanCode);
    execute4(getSemesterEvaluationHW({ lessonPlanCode }));
  };

  const renderTable = () => {
    switch (learningTypeCode) {
      case 'HW':
        if (subjectCode && res5) {
          return (
            <EvaluationHWTable2
              semesterLessonPlans={res5?.data ?? []}
              evaluationItemTree={
                res3?.data?.filter(
                  (item: any) => item.subjectCode === subjectCode,
                ) ?? [] //20240716 subject별로 activity나오게하기
              }
              semesterEvaluationsHW={res4?.data ?? []}
              onRowClick={onRowClick}
              onDelete={onDelete}
              onSubmit={onHWSubmit}
            />
          );
        } else return null;
      case 'PA':
        return (
          <EvaluationTable
            semesterTimetables={res?.data ?? []}
            onSetData={onSetData}
            onDelete={onDelete}
            onSubmit={onSubmit}
            data={data}
          />
        );
      case 'PB':
        return <EvaluationPbt semesterCourseCode={semesterCourseCode} />;
      default:
        return (
          <EvaluationNewTable2
            semesterEvaluations={semesterEvaluations}
            learningTypeCode={learningTypeCode}
            semesterCourseCode={semesterCourseCode}
          />
        );
    }
  };

  return (
    <>
      {(isLoading ||
        isLoading2 ||
        isLoading3 ||
        isLoading4 ||
        isLoading5 ||
        isLoading6 ||
        submitIsLoading ||
        deleteIsLoading) && <Loader />}
      <ErrorResponse error={error} />
      <ErrorResponse error={error2} />
      <ErrorResponse error={error3} />
      <ErrorResponse error={error4} />
      <ErrorResponse error={error5} />
      <ErrorResponse error={error6} />
      <ErrorResponse error={submitError} />
      <ErrorResponse error={deleteError} />

      <div className="comm-bx__space pt-0">
        <div className="comm-btn__area right">
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('program.semester.placeholder1')}
              value={courseIndex}
              onChange={(value) => {
                setLearningTypeCode(undefined);
                setSemesterEvaluations([]);
                const course = chosenCourseList.find(
                  (item: any) => item.value === value,
                );
                if (course) {
                  setData([]);
                  setCourseIndex(value);
                  setCourseCode(course.courseCode);
                  setSemesterCourseCode(courseInput[value].id);
                }
              }}
            >
              {chosenCourseList?.map((item: any) => (
                <Select.Option key={item.value} value={item.value}>
                  {item.label}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="w-150p">
            <Select
              className="w-100"
              placeholder={t('program.semester.placeholder2')}
              value={learningTypeCode}
              onChange={(value) => onSetLearningTypeCode(value)}
              disabled={!courseCode}
            >
              {GR0001?.map((item) => (
                <Select.Option key={item.detailCode} value={item.detailCode}>
                  {item.korName}
                </Select.Option>
              ))}
            </Select>
          </div>
          {learningTypeCode === 'HW' && (
            <div className="w-150p">
              <SelectSemesterCourseSubject
                semesterCourseCode={semesterCourseCode}
                subjectCode={subjectCode}
                setSubjectCode={setSubjectCode}
              />
            </div>
          )}
        </div>
      </div>
      {renderTable()}
    </>
  );
};

export default Evaluation;
